export const getAppointmentTimeOptions = () => {
	let timeOptions: { label: string; value: string }[] = [];

	for (let index = 6; index <= 18; index++) {
		const value = index < 10 ? `0${index}` : index;
		timeOptions = [
			...timeOptions,
			{
				label: `${value}:00`,
				value: `${value}:00:00`,
			},
			{
				label: `${value}:30`,
				value: `${value}:30:00`,
			},
		];
	}

	return timeOptions;
};
